import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *  data: import('utils/ReduxUtils').EntitySlice<import('../types').VehicleCheckModel>,
 *  ui: import('./ui').VehicleCheckModelsUIReducer,
 * }} VehicleChecksModelsReducer
 */

export default combineReducers({
  data,
  ui,
});
